import { render, staticRenderFns } from "./upDataFile.vue?vue&type=template&id=8f96f1a6&scoped=true"
import script from "./upDataFile.vue?vue&type=script&lang=js"
export * from "./upDataFile.vue?vue&type=script&lang=js"
import style0 from "./upDataFile.vue?vue&type=style&index=0&id=8f96f1a6&prod&scoped=true&lang=css"
import style1 from "./upDataFile.vue?vue&type=style&index=1&id=8f96f1a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f96f1a6",
  null
  
)

export default component.exports